// the following article types has no categories page
export const NO_CATEGORY_TYPES = [
  "Glossary Term",
  "glossary",
  "Market Update",
  "Global Logistics Update",
  "case-study",
  "research",
  "capital",
];

// Article type enum for consistent usage
export enum HELP_CENTER_ARTICLE_TYPE {
  HELP_CENTER = "Help Center Article",
  GLOSSARY_TERM = "Glossary Term",
  MARKET_UPDATE = "Market Update",
  GLOBAL_LOGISTICS_UPDATE = "Global Logistics Update",
}

// Article types that should be excluded from /help path
export const EXCLUDED_FROM_HELP_PATH = [
  HELP_CENTER_ARTICLE_TYPE.MARKET_UPDATE,
  HELP_CENTER_ARTICLE_TYPE.GLOBAL_LOGISTICS_UPDATE,
  HELP_CENTER_ARTICLE_TYPE.GLOSSARY_TERM,
];

export const SHORT_MONTHS = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
